var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "design-layout-top"
  }, [_c("a-row", {
    staticClass: "header",
    attrs: {
      type: "flex",
      justify: "space-between",
      align: "middle"
    }
  }, [_c("a-col", {
    staticClass: "left",
    attrs: {
      span: 7
    }
  }), _c("a-col", {
    staticClass: "middle",
    attrs: {
      span: 7
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "200px"
    },
    on: {
      change: _vm.handlePageChange
    },
    model: {
      value: _vm.curPage,
      callback: function callback($$v) {
        _vm.curPage = $$v;
      },
      expression: "curPage"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "design"
    }
  }, [_vm._v("首页装修")]), _c("a-select-option", {
    attrs: {
      value: "designCategory"
    }
  }, [_vm._v("移动端分类装修")])], 1)], 1), _c("a-col", {
    staticClass: "right",
    attrs: {
      span: 6
    }
  }, [_c("a", {
    staticClass: "save",
    class: {
      "is-disabled": !_vm.formEdited
    },
    attrs: {
      href: "javascript:void(0);"
    },
    on: {
      click: _vm.handle_page_save
    }
  }, [_vm._v(_vm._s(_vm.$t("header.save")))]), _c("a", {
    staticClass: "preview",
    attrs: {
      href: "/#/designCategory/preview",
      target: "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.preview")))]), _c("a", {
    staticClass: "release",
    attrs: {
      href: "javascript:void(0);"
    },
    on: {
      click: _vm.handle_page_release
    }
  }, [_vm._v(_vm._s(_vm.$t("header.publish")))])])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };